// Statusni i labelski metapodaci za "Promocije", "Refundacije", "Uplate restorana"
// i "Isplate restoranu" tabove finansija - preslikano sa
// dostavljaci-front/app/utils/{promotion,refund,restaurant-deposit,restaurant-payout}.ts,
// prilagođeno za Vuetify2 boje (success/warning/error/secondary/grey).
//
// Labeli se ne čuvaju kao gotov tekst (label) vec kao i18n kljuc (labelKey),
// jer su ovo plain JS module-level konstante bez pristupa this.$t().

export const PROMOTION_STATUS_META = {
  active: { labelKey: "finance_status_promotion_active", color: "success" },
  completed: { labelKey: "finance_status_promotion_completed", color: "grey" },
  planned: { labelKey: "finance_status_promotion_planned", color: "warning" },
};

export const PROMOTION_FUNDING_META = {
  ordera: "finance_funding_ordera",
  restaurant: "finance_funding_restaurant",
  shared: "finance_funding_shared",
};

export const REFUND_STATUS_META = {
  approved: { labelKey: "finance_status_refund_approved", color: "success" },
  pending: { labelKey: "finance_status_refund_pending", color: "warning" },
  rejected: { labelKey: "finance_status_refund_rejected", color: "grey" },
};

export const DEPOSIT_STATUS_META = {
  confirmed: { labelKey: "finance_status_deposit_confirmed", color: "success" },
  pending: { labelKey: "finance_status_deposit_pending", color: "warning" },
  rejected: { labelKey: "finance_status_deposit_rejected", color: "error" },
};

export const RESTAURANT_PAYOUT_STATUS_META = {
  completed: { labelKey: "finance_status_restaurant_payout_completed", color: "success" },
  processing: { labelKey: "finance_status_restaurant_payout_processing", color: "warning" },
  failed: { labelKey: "finance_status_restaurant_payout_failed", color: "error" },
};

// currency defaults to "KM" only as a last-resort fallback; callers should
// pass the restaurant's configured currency (see global `restaurantCurrency` mixin in main.js).
export function formatCurrency(value, currency = "KM") {
  const num = Number(value);
  return `${Number.isFinite(num) ? num.toFixed(2) : "0.00"} ${currency}`;
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("sr-RS", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
